module.exports = __webpack_public_path__ + "img/LogoDashboard-4.5ec07388.svg";